import { AxiosResponse } from 'axios';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { NotificationMessage } from '../../../../../../components';
import * as service from '../services';

export const useSaveAderencia = () => {
  const queryClient = useQueryClient();

  const successAction = () => {
    queryClient.invalidateQueries(['get-setup-aderencia-uploads']);
    NotificationMessage('success', 5000, 'Alterações foram salvas com sucesso');
  };

  const errorAction = (data: AxiosResponse) => {
    if (data.response) {
      const mensagem = data.response.data[0]?.mensagem || 'Erro desconhecido';
      const mensagemTratada = mensagem.replace(/IllegalArgumentException:\s*/, '');
      NotificationMessage('error', 5000, mensagemTratada);
    }
  };

  const saveCoverageMutation = useMutation({
    mutationFn: (payload: string) => service.saveAderencia(payload),
    onSuccess: successAction,
    onError: errorAction,
  });

  return {
    handleSaveAderenciaMutation: saveCoverageMutation.mutate,
  };
};
